import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const RegistrationSuccessPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/checkup');
        }, 5000);
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <main className="layout__content">
            <section className="section layout__section auth">
                <div className="container">
                    <div className="auth__block auth-block" style={{ textAlign: 'center' }}>
                        <header className="auth-block__header">
                            <h1 className="title auth-block__title">Регистрация<br />прошла успешно</h1>
                        </header>

                        <div className="auth-block__content">
                            <p className="auth-form__hint-text" style={{ marginBottom: 20 }}>
                                Поздравляем! Теперь вы можете войти в свой личный кабинет, чтобы получить доступ к сервисам.
                            </p>

                            <div style={{ margin: '30px auto' }}>
                                <svg width="118" height="118" viewBox="0 0 118 118" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="59" cy="59" r="58.5" stroke="#D3D3D3" strokeDasharray="5 5" />
                                    <circle cx="59" cy="59" r="49.5" fill="white" stroke="#DDDDDD" />
                                    <circle cx="59" cy="59" r="50" fill="#E2EF4A" />
                                    <path d="M52.875 74L38.625 59.75L42.1875 56.1875L52.875 66.875L75.8125 43.9375L79.375 47.5L52.875 74Z" fill="#277871" />
                                </svg>
                            </div>

                            <p className="auth-form__hint-text" style={{ marginTop: 24 }}>
                                Вы будете автоматически перенаправлены<br />на главную страницу.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};
